import { SharedModels } from "@/data/shared/shared.models";
import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { S3RestClient } from "@/util/rest/clients/s3-rest-client";

import { MediaModels } from "./media.models";

export namespace MediaApi {
  export const getPresignedUrl = async (type: MediaModels.Use) => {
    const response = await AppRestClient.post(
      { resSchema: MediaModels.GetPresignedURLResponseSchema },
      `/media/presigned-url?use=${type}`,
    );
    return MediaModels.GetPresignedURLResponseSchema.parse(response);
  };

  export const uploadPut = (req: MediaModels.PutUploadRequest) => {
    return S3RestClient.put({ resSchema: SharedModels.EmptySchema }, req.url, req.file, {
      onUploadProgress: req.onUploadProgress,
      signal: req.abortController?.signal,
    });
  };

  export const uploadPost = (req: MediaModels.PostUploadRequest) => {
    const formData = new FormData();
    Object.entries(req.fields).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append("file", req.file, req.file.name);

    return S3RestClient.post({ resSchema: SharedModels.EmptySchema }, req.url, formData, {
      onUploadProgress: req.onUploadProgress,
      signal: req.abortController?.signal,
    });
  };
}
